import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { LazyImage } from '@crehana/ui';
import { clsx } from 'clsx';

import type { LazyLogoProps } from './types';

const LazyLogo: FC<React.PropsWithChildren<LazyLogoProps>> = ({
  slug,
  isDark = true,
  src,
  collapsed,
}) => {
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!src) return null;
  return (
    <LazyImage
      src={src}
      imgClassName="object-contain"
      alt={slug || ''}
      imgxParams={collapsed ? { h: 24, w: 24 } : { h: 40, w: '100%' }}
      className={clsx(
        collapsed ? 'h-24 w-24' : 'h-32 w-full sm:h-40 mx-24 sm:mx-36',
      )}
      isTransparent
      isDark={isDark}
    />
  );
};

export default LazyLogo;
